// Ewg
import EwgDialog from "./common/EwgDialog.vue";
import EwgTooltip from "./common/EwgTooltip.vue";
import EwgTab from "./common/EwgTab.vue";

// dialog
import AttrsDialog from "./Dialog/attrs.vue";
import PackDialog from "./Dialog/Pack/index.vue";
import StoreDialog from "./Dialog/Store/index.vue";
import TowerDialog from "./Dialog/Tower/index.vue";
import TradeDialog from "./Dialog/Trade/index.vue";

// confirm
import ExitConfirm from "./Confirm/exit.vue";
// tooltip
import EquipTooltip from "./Tooltip/equip.vue";
export default {
  /** 通用组件 */
  EwgDialog,
  EwgTooltip,
  EwgTab,
  /** dialog */
  AttrsDialog,
  PackDialog,
  StoreDialog,
  TowerDialog,
  TradeDialog,
  /** confirm */
  ExitConfirm,
  /** tooltip */
  EquipTooltip
};
